import { Injectable } from '@angular/core';

@Injectable()
export class Receipt {

    public transactionId;
    public invoiceId;
    public accountId;
    public date;
    public payment;
    public amount;
    public referenceNumber;
    public cardNumber;
    public transactionType;
    public cardType;
    public responseMessage;
    public authCode;
    public avsResult;
    public currency;
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/shared/models/receipt.ts